// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__B34jW","content":"LoadingAlert_content__2k8eE"};